import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { AuthProvider } from './auth/AuthContext'
import { ToastProvider } from './components/ToastProvider'
import { SyncProvider } from './offline/SyncContext'
import '@fontsource-variable/noto-sans/wght.css'
import './styles/global.css'
import './styles/executor.css'
import './styles/management.css'
import './styles/journal.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SyncProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </SyncProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((registration) => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
    void registration.update()
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) void registration.update()
    })
  }).catch(() => undefined)
}
